/* eslint-disable react-hooks/exhaustive-deps */
import { useStateSelector } from '../../../data/global/dataSelectors';
import { blockSettings } from '../../../data/global/selectors/settingSelectors';
import { useBlockId } from '../../../components/blocks/BlockState';

export const useOrderBlockSettings = (blockId?: string) => {
  return useStateSelector(s => blockSettings.order(s, blockId));
};
export const useOrderSettings = () => {
  const blockId = useBlockId();
  return useOrderBlockSettings(blockId);
};
